import { useQuery } from "react-query";
import { API_URL } from "../../../../BaseUrlApi/Url";
import API from "@Config/axios";

export const useGetProvince = (provinceId) => {
  return useQuery(
    ["province", provinceId],
    async () => {
      if (!provinceId) return null;
      const response = await API.get(
        `${API_URL}/regions/provinces?id=${provinceId}`
      );
      return response.data.provinces?.name || "-";
    },
    { enabled: !!provinceId }
  );
};
